
import { ISelectItem } from "../classes/select-item";
import { Validatable } from "../mixins/validatable";

export default Validatable.extend({
	data() {
		return {
			selectedItems: [] as any[]
		};
	},
	props: {
		items: {
			type: Array as () => ISelectItem<any>[],
			default: () => []
		},
		value: {},
		up: {
			type: Boolean
		},
		label: {
			type: [String, Object]
		},
		fancy: Boolean,
		light: Boolean,
		disabled: Boolean,
		filter: Boolean,
		right: Boolean,
		emptyText: {
			type: [String, Object],
			default: ""
		},
		hasError: Boolean
	},
	watch: {
		value: {
			immediate: true,
			handler(newValue:any) {
				if (!newValue) {
					this.selectedItems = [newValue];
					return;
				}
				if (newValue != this.selectedItems[0]) {
					this.selectedItems = [newValue];
				}
			}
		}
	},
	methods: {
		focus() {
			(this.$refs.root as any).focus();
		},
		keyup(event: KeyboardEvent) {
			if (event.key == "ArrowDown"){
				event.preventDefault();
				event.stopPropagation();
				let currentValueIndex = this.items.findIndex(v=>this.value == v.value);
				if (currentValueIndex == -1) {
					this.setValue(this.items[0].value);
					return;
				};
				if (currentValueIndex >= this.items.length-1) return;
				let v = this.items[currentValueIndex+1].value;
				this.setValue(v);
			}else if (event.key == "ArrowUp") {
				event.preventDefault();
				event.stopPropagation();
				let currentValueIndex = this.items.findIndex(v=>this.value == v.value);
				if (currentValueIndex == -1) {
					this.setValue(this.items[0].value);
					return;
				};
				if (currentValueIndex <= 0) return;
				let v = this.items[currentValueIndex-1].value;
				this.setValue(v);
			}
			this.$emit("keyup", event);
		},
		setValue(v:any){
			this.selectedItems.splice(0, this.selectedItems.length);
			this.selectedItems.push(v);
			this.onInput(this.selectedItems);
		},
		onInput(newValue:any[]) {
			if (newValue.length >= 2) {
				this.selectedItems = [newValue[1]];
			}
			if (newValue.length == 0 && this.value != null) {
				this.selectedItems = [this.value];
			}
			this.$emit("input", this.selectedItems[0]);
		}
	},
	mounted() {
		if (this.value != null) {
			this.selectedItems = [this.value];
		}
	},
});
